export default __webpack_public_path__ + "static/media/biophilic-design.8bd424b0.svg";